import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class InvoicePaymentService {

  constructor(private http: HttpClient) { }

  saveInvoicePayment(company: any, payload: any) {
    return this.http.post(urls.API_URL + urls.PAYMENTS + '/' + company, payload)
      .pipe(catchError(errorHandl));
  }

  getInvoicePayments(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.PAYMENTS, { params })
      .pipe(catchError(errorHandl));
  }

  getInvoicePaymentById(id: any) {
    return this.http.get(urls.API_URL + urls.PAYMENTS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  voidPayment(company: any, id: any) {
    return this.http.post(urls.API_URL + urls.PAYMENTS + `/${company}/${id}/void`, {})
      .pipe(catchError(errorHandl));
  }

  deletePayment(company: any, id: any) {
    return this.http.delete(urls.API_URL + urls.PAYMENTS + `/${company}/${id}`)
      .pipe(catchError(errorHandl));
  }

  syncInvoicePayment(company: any, id: any, queryParams: any = {}) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.PAYMENTS + `/${company}/${urls.SYNC}/${id}`, { params })
      .pipe(catchError(errorHandl));
  }
}
